document.addEventListener('turbolinks:load', function () {
    if ($('.v2_permit_applications-form-section').length === 0) {
        return false
    }

    let form = document.querySelector('#v2-permit-application-form');
    processStep();

    function processStep() {
        $('.previous-step-btn').on('click', function (e) {
            e.preventDefault();

            var targetId = $(this).data("target")
            // do not submit form when back button is clicked on permit selection step to go to city selection step
            if (targetId === 'city-selection') {
                window.location = window.location.href.split("?")[0];
            } else {
                submitForm(targetId)
                window.scrollTo(0, 0)
            }
        });

        $('.next-step-btn').on('click', function (e) {
            e.preventDefault();

            let currentSection = $(`#${$(e.target).data('current')}`);
            var targetId = $(this).data("target")

            if (currentSection.length !== 0) {
                handleRequiredFields(e, targetId, currentSection)
            } else {
                submitForm(targetId)
                window.scrollTo(0, 0)
            }
        });

        $('.create-project-btn').on('click', function (e) {
            // determines if the project is created or updated

            var projectCreationAction = $(this).data("project-creation-action")
            if (projectCreationAction && projectCreationAction.length !== 0) {
                $(form).append('<input type="hidden" name="project_creation_action" id="project_creation_action" value=""/>')
                $(form).find("#project_creation_action").val(projectCreationAction)
            }
        });
    }

    $(document).on('input', '.wholeNumberField', function() {
        let field = $(this);
        if (field[0].checkValidity()) {
            field.removeClass('is-invalid').removeClass('error-field');
            field.siblings('.whole-number-error').remove();
        }
    });

    // Add real-time validation for required fields
    $(document).on('blur', "input.requiredField, select.requiredField, .requiredField input[type='checkbox'], .requiredField input[type='file']", function() {
        validateSingleField($(this));
    });

    $(document).on('change', "input.requiredField, select.requiredField, .requiredField input[type='checkbox'], .requiredField input[type='file']", function() {
        validateSingleField($(this));
    });

    function handleRequiredFields(e, targetId, currentSection) {
        let validationResult = validateRequiredFields(currentSection);
        let numberFieldValidationResult = validateNumberField(currentSection);

        if (!validationResult.isValid || !numberFieldValidationResult.isValid) {
            let firstErrorField = validationResult.firstErrorField || numberFieldValidationResult.firstErrorField;
            if (firstErrorField) {
                firstErrorField[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            hideLoader();
            return;
        }

        submitForm(targetId)
        hideLoader();
    }

    function validateRequiredFields(section) {
        let isValid = true;
        let firstErrorField = null;

        // Clear previous error states
        section.find('.requiredField').removeClass('is-invalid').removeClass('error-field');
        section.find('.required-field-error').remove();

        section.find('.requiredField').each(function() {
            let field = $(this);
            let fieldValue = field.val();
            let isFieldValid = true;

            if (field.hasClass('document-form-card')) {
                var filesPresent = $(field).attr('data-files-present')
                if (fieldValue.length === 0 && filesPresent !== "true") {
                    isFieldValid = false;
                }
            } else if (field.hasClass('checkbox-form-field')) {
                if ($(field).find('input:checkbox:checked').length === 0) {
                    isFieldValid = false;
                }
            } else {
                if (fieldValue === null || fieldValue.length === 0 || fieldValue.trim() === '') {
                    isFieldValid = false;
                }
            }

            if (!isFieldValid) {
                isValid = false;
                if (!firstErrorField) {
                    firstErrorField = field;
                }

                // Add error styling and message
                field.addClass('is-invalid').addClass('error-field');
                showFieldErrorMessage(field);
            }
        });

        return {
            isValid: isValid,
            firstErrorField: firstErrorField
        };
    }

    function validateNumberField(section) {
        let isValid = true;
        let firstErrorField = null;

        section.find('.whole-number-error').remove();

        section.find('.wholeNumberField').each(function() {
            let field = $(this);
            let input = field[0];
            let fieldValue = field.val();

            if (!fieldValue || fieldValue.trim() === '') {
                return;
            }

            if (!input.checkValidity()) {
                isValid = false;
                if (!firstErrorField) {
                    firstErrorField = field;
                }
                field.addClass('is-invalid').addClass('error-field');
                field.after('<span class="error-message whole-number-error">' + input.validationMessage + '</span>');
            } else {
                field.removeClass('is-invalid').removeClass('error-field');
            }
        });

        return {
            isValid: isValid,
            firstErrorField: firstErrorField
        };
    }

    function validateSingleField(field) {
        let fieldValue = field.val();
        let fieldType = field.attr('type');

        // file input is being handled by dropzone js so not handling here
        if (fieldType === 'checkbox') {
            let validationField = $(field).parents('.checkbox-form-field');
            validationField.removeClass('is-invalid').removeClass('error-field');

            if (validationField.find('input:checkbox:checked').length === 0) {
                validationField.addClass('is-invalid').addClass('error-field');
            }
        } else {
            field.removeClass('is-invalid').removeClass('error-field');
            field.siblings('.required-field-error').remove();

            if (fieldValue === null || fieldValue.length === 0 || fieldValue.trim() === '') {
                field.addClass('is-invalid').addClass('error-field');
                showFieldErrorMessage(field);
            }
        }
    }

    function showFieldErrorMessage(field) {
        let errorMessage = field.data('error-message');
        if (!errorMessage) {
            return;
        }

        field.after('<span class="error-message required-field-error">' + errorMessage + '</span>');
    }

    function submitForm(targetId) {
        assignFormValue(targetId)
        submitPermitForm()
    }

    function assignFormValue(targetId) {
        $('#next_tab_id').val(targetId);
    }

    function submitPermitForm() {
        // Add submit event listener to show loader only when form is actually submitted
        form.addEventListener('submit', function () {
            showLoader();
        });

        let button = document.createElement('input');
        button.style.display = 'none';
        button.type = 'submit';
        button.formNoValidate = true;
        form.appendChild(button).click();
        form.removeChild(button);
    }

    function showLoader() {
        $('.loading-spinner').show();
        $('body').css({
            pointerEvents: "none"
        })
    }

    function hideLoader() {
        $('.loading-spinner').hide();
        $('body').css({
            pointerEvents: "auto"
        });
    }
});